/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import * as AvailabilityHelpers from '../../helpers/storeHelpers';
import * as Styled from './ProductAvailability.styles';
var PROP_TYPES = {
  products: PropTypes.array
};
var DEFAULT_PROPS = {
  products: []
};
var ICONS = {
  TICK: 'tick',
  CLOCK: 'clock',
  CALENDAR: 'calendar',
  OUTOFSTOCK: 'out_of_stock',
  WARNING: 'triangle',
  NONE: null
};

var availabilitycolour = function availabilitycolour(icon) {
  return icon === ICONS.TICK || icon === ICONS.CLOCK || icon === ICONS.CALENDAR ? 'available' : 'unavailable';
};

var ProductsBlock = function ProductsBlock(_ref) {
  var products = _ref.products;
  return /*#__PURE__*/React.createElement(Styled.ProductList, {
    className: "xs-12--negative"
  }, products.map(function (product, index) {
    var _product$leadtime = product.leadtime,
        text = _product$leadtime.text,
        icon = _product$leadtime.icon;
    return /*#__PURE__*/React.createElement(Styled.ProductBlockListItem, {
      className: "xs-12 md-6",
      background: availabilitycolour(icon),
      key: index
    }, /*#__PURE__*/React.createElement(Styled.ProductBlockListItemImg, {
      src: "//media.4rgos.it/s/Argos/".concat(product.sku, "_R_SET?$Thumb220$&$Web$")
    }), /*#__PURE__*/React.createElement(Styled.ProductBlockListItemDiv, null, /*#__PURE__*/React.createElement(Styled.StyledAvailabilityIcon, {
      type: icon,
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("small", null, text)));
  }));
};

var ProductsRow = function ProductsRow(_ref2) {
  var organisedProducts = _ref2.organisedProducts;
  return /*#__PURE__*/React.createElement(Styled.ProductList, null, Object.keys(organisedProducts).map(function (key, index) {
    var icon = organisedProducts[key][0].leadtime.icon;
    return /*#__PURE__*/React.createElement(Styled.ProductRowListPanelDiv, {
      background: availabilitycolour(icon),
      key: key + index
    }, /*#__PURE__*/React.createElement(Styled.ProductRowListMessageDiv, null, /*#__PURE__*/React.createElement(Styled.StyledAvailabilityIcon, {
      type: icon,
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("p", null, key)), /*#__PURE__*/React.createElement(Styled.ProductRowListContent, null, organisedProducts[key].map(function (product, pindex) {
      return /*#__PURE__*/React.createElement(Styled.ProductRowListImgWrapper, {
        key: product.leadtime.messageKey + pindex
      }, /*#__PURE__*/React.createElement(Styled.ProductBlockListItemImg, {
        src: "//media.4rgos.it/s/Argos/".concat(product.sku, "_R_SET?$Thumb220$&$Web$")
      }));
    })));
  }));
};

var ProductAvailability = function ProductAvailability(_ref3) {
  var products = _ref3.products;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "product-availability-wrapper"
  }, products.length <= 4 && /*#__PURE__*/React.createElement(ProductsBlock, {
    products: products
  }), products.length > 4 && /*#__PURE__*/React.createElement(ProductsRow, {
    organisedProducts: AvailabilityHelpers.organiseProducts(products)
  }));
};

ProductAvailability.propTypes = PROP_TYPES;
ProductAvailability.defaultProps = DEFAULT_PROPS;
export default ProductAvailability;